import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { getLatestNews } from "@/utils/content";

export default function NewsSection() {
  const news = getLatestNews(6);
  const [lead, ...rest] = news;

  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="News"
        title="影视资讯快讯"
        subtitle="行业动态、幕后揭秘与奖项资讯，第一时间掌握影视世界的风吹草动。"
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <article className="group">
          <Link to={lead.workId ? `/detail/${lead.workId}` : "/"} className="cursor-pointer">
            <div className="relative w-full aspect-[16/10] overflow-hidden rounded-lg bg-background-200">
              <img
                src={lead.image}
                alt={lead.title}
                title={`${lead.title} 影视资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-primary-950">
                {lead.category}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-2xl">
              {lead.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
            <p className="mt-3 text-xs text-foreground-500">{lead.date}</p>
          </Link>
        </article>

        <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {rest.map((item) => (
            <article key={item.id} className="group">
              <Link
                to={item.workId ? `/detail/${item.workId}` : "/"}
                className="flex cursor-pointer items-start gap-4 p-4 md:p-5"
              >
                <div className="relative h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img src={item.image} alt={item.title} title={item.title} className="h-full w-full object-cover object-top" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="mb-1 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="font-medium text-accent-700">{item.category}</span>
                    <span>{item.date}</span>
                  </div>
                  <h4 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                    {item.title}
                  </h4>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}